import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BusinessUnitDTO} from '../../model/bench-entry.model';

@Component({
  selector: 'app-bu-badge',
  templateUrl: './bu-badge.component.html',
  styleUrl: './bu-badge.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuBadgeComponent {
  @Input() bu: BusinessUnitDTO | null = null;
}